const CLIENT_URL_STR = "your.url.here"

export { CLIENT_URL_STR }
